import { render } from "./Modals.vue?vue&type=template&id=290d2af2"
import script from "./Modals.vue?vue&type=script&lang=js"
export * from "./Modals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__